export default __webpack_public_path__ + "images/loggedout/home/modularPage/bedtime_stories-532d61ad3d5eb501f425691dcfe9e262.png";